import { Box, TablePagination as Pagination } from "@mui/material";
import { useContext } from "react";

import ContextControlTable from "./contextTable";

// ----------------------------------------------------------------------

type Props = {
	count: number;
};

export default function TablePagination({ count }: Props) {
	const { rowsPerPage, onChangeRowsPerPage, onChangePage, page } = useContext(ContextControlTable);

	return (
		<Box sx={{ position: "relative" }}>
			<Pagination
				component='div'
				count={count}
				page={page}
				onPageChange={onChangePage}
				rowsPerPageOptions={[10, 20]}
				rowsPerPage={rowsPerPage}
				labelRowsPerPage={"Transacciones por página"}
				onRowsPerPageChange={onChangeRowsPerPage}
			/>
		</Box>
	);
}
